import { useCallback } from "react";
import { submitlogs } from "../api/questionnaire";

export const useLogging = () => {
  // Helper function for logging that accepts context dynamically
  const logUserAction = useCallback(
    async (actionType, context = {}, additionalData = {}) => {
      const { participantCode, assignedMode, currentImage } = context;

      if (participantCode) {
        const logData = {
          participantCode: participantCode,
          logs: {
            participantCode: participantCode,
            assignedMode: assignedMode,
            imageurl: currentImage?.imageUrl || "N/A",
            activity: actionType,
            startTime: additionalData?.startTime || "N/A",
            endTime: additionalData?.endTime || "N/A",
            durationMs: additionalData?.durationMs ?? "N/A",
            durationSeconds: additionalData?.durationSeconds ?? "N/A",
            element: additionalData?.element ?? "N/A",
            // Semantic-interaction fields (nullable). `detail` is JSON-encoded
            // so arbitrary per-event metadata survives the fixed payload shape.
            phase: additionalData?.phase ?? null,
            imageIndex: additionalData?.imageIndex ?? null,
            targetType: additionalData?.targetType ?? null,
            targetId: additionalData?.targetId ?? null,
            targetText: additionalData?.targetText ?? null,
            detail:
              additionalData?.detail == null
                ? null
                : typeof additionalData.detail === "string"
                ? additionalData.detail
                : JSON.stringify(additionalData.detail),
          },
        };
        await submitlogs(logData);
      }
    },
    []
  );

  return {
    logUserAction,
  };
};
